'use client';
import React, { useState } from 'react';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';

const faqs = [
  {
    category: 'عام',
    items: [
      {
        q: 'ما هي منصة تصريح؟',
        a: 'منصة تصريح هي البوابة الرسمية لوزارة الخارجية وشؤون المغتربين لتقديم ومتابعة خدمات التأشيرات وجوازات السفر والخدمات القنصلية إلكترونيًا.',
      },
      {
        q: 'هل المنصة رسمية؟',
        a: 'نعم، المنصة رسمية ومعتمدة من وزارة الخارجية وشؤون المغتربين للجمهورية اليمنية.',
      },
    ],
  },
  {
    category: 'التأشيرات',
    items: [
      {
        q: 'كيف أتقدم على تأشيرة دخول اليمن؟',
        a: 'يمكنك التقدم عبر المنصة بعد إنشاء حساب وملء نموذج الطلب ورفع المستندات المطلوبة.',
      },
      {
        q: 'كم تستغرق معالجة طلب التأشيرة؟',
        a: 'يستغرق متوسط المعالجة من 3 إلى 5 أيام عمل بعد استيفاء جميع المتطلبات.',
      },
      {
        q: 'ما هي رسوم طلب التأشيرة؟',
        a: 'رسوم تأشيرة دخول اليمن 50 دولار أمريكي، ورسوم الموافقة الأمنية للمواطنين اليمنيين 60 دولار أمريكي.',
      },
    ],
  },
  {
    category: 'جواز السفر',
    items: [
      {
        q: 'كيف أجدد جواز سفري؟',
        a: 'يمكنك تقديم طلب تجديد جواز السفر عبر المنصة من قسم خدمات جواز السفر.',
      },
      {
        q: 'ماذا أفعل إذا فقدت جواز سفري؟',
        a: 'يمكنك تقديم طلب بدل فاقد عبر المنصة مع تقديم بلاغ فقدان من الجهات المختصة.',
      },
    ],
  },
  {
    category: 'الدفع والرسوم',
    items: [
      {
        q: 'ما هي طرق الدفع المتاحة؟',
        a: 'تقبل المنصة الدفع عبر بطاقات الائتمان والتحويلات البنكية وبعض محافظ العملات الرقمية.',
      },
      {
        q: 'هل الدفع آمن؟',
        a: 'نعم، جميع عمليات الدفع مشفرة ومؤمنة وفق أعلى معايير الأمان الإلكتروني.',
      },
    ],
  },
];

export default function FAQPage() {
  const [openItem, setOpenItem] = useState<string | null>(null);

  return (
    <div className="min-h-screen flex flex-col font-tajawal" dir="rtl">
      <Navbar activePage="/faq" />
      <main className="flex-1 bg-background">
        {/* Header */}
        <div className="bg-gradient-to-br from-primary to-accent py-14">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 text-white border border-white/20 text-xs font-medium mb-4">
              ❓ الأسئلة الشائعة
            </div>
            <h1 className="text-3xl sm:text-4xl font-extrabold text-white mb-3">الأسئلة الشائعة</h1>
            <p className="text-white/70 max-w-xl mx-auto text-sm">
              إجابات على أكثر الأسئلة شيوعًا حول خدمات المنصة
            </p>
          </div>
        </div>

        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
          {faqs?.map((section) => (
            <div key={section?.category} className="mb-10">
              <h2 className="text-lg font-bold text-primary mb-4 flex items-center gap-2">
                <span className="w-1 h-5 bg-primary rounded-full inline-block"></span>
                {section?.category}
              </h2>
              <div className="space-y-3">
                {section?.items?.map((item) => {
                  const key = `${section?.category}-${item?.q}`;
                  const isOpen = openItem === key;
                  return (
                    <div key={key} className="bg-white rounded-xl border border-border overflow-hidden">
                      <button
                        onClick={() => setOpenItem(isOpen ? null : key)}
                        className="w-full flex items-center justify-between px-5 py-4 text-right hover:bg-muted transition-colors"
                      >
                        <span className="font-semibold text-sm text-foreground">{item?.q}</span>
                        <svg
                          className={`w-5 h-5 text-muted-foreground transition-transform shrink-0 mr-3 ${isOpen ? 'rotate-180' : ''}`}
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                      </button>
                      {isOpen && (
                        <div className="px-5 pb-4 text-sm text-muted-foreground leading-relaxed border-t border-border">
                          <p className="pt-3">{item?.a}</p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}

          {/* Contact CTA */}
          <div className="bg-primary/5 rounded-2xl border border-primary/20 p-6 text-center mt-8">
            <h3 className="font-bold text-foreground mb-2">لم تجد إجابة لسؤالك؟</h3>
            <p className="text-sm text-muted-foreground mb-4">تواصل مع فريق الدعم الفني وسيسعدك فريقنا</p>
            <a href="/contact">
              <button className="gov-btn-primary">تواصل معنا</button>
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
